import classNames from 'classnames';
import { forwardRef } from 'react';
import { SegmentFilterDisplayInfo } from 'src/shared/utils/SegmentFilterUtils';
import { Icon } from 'web-common/src/shared/design-system/components/Icon';

export type CuisineButtonProps = {
  cuisineFilter: string;
  title: string;
  isSelected?: boolean;
  disabled?: boolean;
  showInline?: boolean;
  rootCuisineFilter?: string;
  underline?: boolean;
  onChange: (cuisine: string) => void;
};

const CuisineButton = forwardRef<HTMLButtonElement, CuisineButtonProps>(
  ({ cuisineFilter, title, isSelected = false, disabled, showInline, rootCuisineFilter, underline, onChange }, ref) => {
    const filterDisplayInfo = SegmentFilterDisplayInfo[cuisineFilter];
    const rootFilterDisplayInfo = SegmentFilterDisplayInfo[rootCuisineFilter ?? ''];
    const displayInfo = filterDisplayInfo ?? rootFilterDisplayInfo;
    const iconName = displayInfo ? (isSelected ? displayInfo.hoverIcon : displayInfo.icon) : undefined;

    const buttonClasses = classNames('flex cursor-pointer items-center', {
      'flex-col justify-center border-none bg-none': showInline,
      'flex-row justify-start gap-2 rounded-lg border px-4 py-2': !showInline,
      'bg-eggplant-600 border-eggplant-600': isSelected && !showInline,
      'border-neutral-300 bg-white': !isSelected && !showInline,
      'opacity-50 cursor-not-allowed': disabled,
    });

    const labelClasses = classNames('font-sans whitespace-nowrap', {
      'text-eggplant font-medium': isSelected && showInline && !disabled,
      'text-eggplant-500 font-medium': !isSelected || disabled,
      'text-milk font-medium': isSelected && !showInline,
      'text-xs': showInline,
      'text-sm': !showInline,
      underline: isSelected && underline,
    });

    if (!displayInfo) {
      return (
        <div className='flex flex-col items-center p-3'>
          <div className='mb-3 size-12 rounded-full bg-neutral-100'></div>
          <div className='h-2.5 w-20 rounded-sm bg-neutral-100'></div>
        </div>
      );
    }

    return (
      <button
        ref={ref}
        className={buttonClasses}
        data-active={isSelected}
        disabled={disabled}
        onClick={() => !disabled && onChange(cuisineFilter)}>
        <Icon name={iconName} size={showInline ? 64 : 48} />
        <div className={labelClasses}>{title}</div>
      </button>
    );
  }
);

export { CuisineButton };

export const LoadingCuisineButton = () => (
  <div className='flex flex-col items-center p-3'>
    <div className='mb-3 size-12 rounded-full bg-neutral-100'></div>
    <div className='h-2.5 w-20 rounded-sm bg-neutral-100'></div>
  </div>
);
